import axios from 'axios';
import { ISubmitResponse } from '../../../../../../../../types/shared/PrequalificationDataEntry';
import SessionStorage from '../../../../../../../../utils/SessionStorage';
import { AcquisitionFlow, callDataExposureApi, getDataEntryPages, withQueryParams } from '../../../../../../../../utils/acquisition-utils';
import { flowDataModule } from '../../../../../../../../utils/flowDataModule';
import { usePageProperties } from '../../../../../../providers/PagePropertiesProvider';
import { usePersonalInformation } from '../../../../../../providers/PersonalInformationProvider';
import setCardInfo from '../util/setCardInfo';
import setSelectedProgramCode from '../util/setSelectedProgramCode';
import useGetDynamicContent from './useGetDynamicContent';

export default function usePrequalDeclined() {
    const { esignConsentRedirectUrl } = usePageProperties();

    const {
        personalInformation: {
            MailingAddressLine1,
            MailingAddressLine2,
            MailingCity,
            MailingState,
            MailingZipCode,
        },
    } = usePersonalInformation();

    const { getDynamicContent } = useGetDynamicContent();

    const declinedFlow = async (data: ISubmitResponse) => {
        const { IsSecuredCardPromotion, ApplicationInformation } = data;

        if (ApplicationInformation && IsSecuredCardPromotion) {
            const { ProgramRates } = ApplicationInformation[0];

            SessionStorage.set('IsSecuredCardPromotion', 'true');

            setCardInfo(data);

            await flowDataModule.updateInSession({
                Cards: SessionStorage.getObject('cardInfo'),
            });

            setSelectedProgramCode(ProgramRates);

            const responseWithAddress = JSON.parse(JSON.stringify(data));
            const applicantAddress = {
                AddressLineOne: MailingAddressLine1,
                AddressLineTwo: MailingAddressLine2,
                City: MailingCity.replace(/\./gi, ''),
                State: MailingState,
                ZipCode: MailingZipCode,
            };
            responseWithAddress.applicantAddress = applicantAddress;
            SessionStorage.setObjectWithCurrentScope(
                'prequalResponse',
                responseWithAddress,
            );

            if (ProgramRates?.ProgramCode) {
                await axios.get(`/services/appoffermodule?programCode=${ProgramRates.ProgramCode}`).catch(() => {
                    const queryParams = new URLSearchParams(window.location.search);
                    queryParams.set('errorCode', 'noTncError');
                    const { preQualDataEntryPageUrl } = getDataEntryPages();
                    window.location.assign(`${preQualDataEntryPageUrl}?${queryParams.toString()}`);
                });
            }

            return getDynamicContent(
                SessionStorage.tryGet('selectedProgramCode', ''),
            )
                .then(async () => callDataExposureApi(AcquisitionFlow.PQ))
                .then(() => {
                    window.location.assign(
                        withQueryParams(esignConsentRedirectUrl),
                    );
                });
            
        }

        return window.location.assign(
            withQueryParams(esignConsentRedirectUrl),
        );
    };

    return {
        declinedFlow,
    };
}
